import { g as getFieldValue, f as formatPhoneForKlaviyo, s as subscribeToKlaviyo } from "./klaviyoSubscription.js";
import { d, E } from "./preact-signals.js";
class KlaviyoForm extends HTMLElement {
  constructor() {
    super();
    this.submitted = d(false);
    this.submitting = d(false);
    this.form = this.querySelector("form");
    if (!this.form) {
      console.warn("No form found in KlaviyoForm");
      return;
    }
    this.submitBtn = this.form.querySelector('[type="submit"]');
    this.successMessage = this.querySelector(".klaviyo-success-message");
    this.listId = this.dataset.listId;
    this.companyId = this.dataset.companyId;
    if (!this.companyId) {
      console.warn("No companyId found in KlaviyoForm");
      return;
    }
    this.successUrl = this.dataset.successUrl;
    E(() => {
      if (this.submitting.value) {
        this.submitBtn.classList.add("loading");
      } else {
        this.submitBtn.classList.remove("loading");
      }
    });
    this.form.addEventListener("submit", (e) => {
      e.preventDefault();
      e.stopPropagation();
      console.log("Form submission prevented");
      this.handleSubmit(e);
    });
  }
  async handleSubmit(e) {
    console.log("submitting");
    this.submitting.value = true;
    const formData = new FormData(this.form);
    const formObject = {};
    formData.forEach((value, key) => formObject[key] = value);
    console.log(formObject);
    const phoneValue = getFieldValue(formObject, "phoneNumber");
    if (phoneValue) {
      const phoneValidation = formatPhoneForKlaviyo(phoneValue);
      if (!phoneValidation.isValid) {
        alert(`Phone number error: ${phoneValidation.error}`);
        return false;
      }
    }
    try {
      const newsletterLists = formData.getAll("newsletter-lists[]");
      if (newsletterLists.length > 0) {
        await subscribeToKlaviyo({
          email: getFieldValue(formObject, "email"),
          formData: formObject,
          companyId: this.companyId,
          listIds: newsletterLists
        });
      }
      const hasNewsletterSignup = formData.get("newsletter-signup");
      const shouldSubscribeToDefault = hasNewsletterSignup || !newsletterLists.length && this.listId;
      if (shouldSubscribeToDefault && this.listId) {
        await subscribeToKlaviyo({
          email: getFieldValue(formObject, "email"),
          formData: formObject,
          companyId: this.companyId,
          listIds: this.listId
        });
      }
      this.submitted.value = true;
      if (this.successUrl) {
        window.location.href = this.successUrl;
        return;
      }
      this.form.classList.add("hidden");
      if (this.successMessage) {
        this.successMessage.classList.remove("hidden");
      }
    } catch (error) {
      console.error("Klaviyo subscription failed:", error);
      if (error.message.includes("Phone validation failed")) {
        alert(error.message.replace("Phone validation failed: ", ""));
      } else if (error.message.includes("phone number")) {
        alert(`Phone number issue: ${error.message}`);
      } else {
        alert(`Subscription failed: ${error.message}`);
      }
      return false;
    } finally {
      this.submitting.value = false;
    }
    return false;
  }
}
if (!customElements.get("klaviyo-form")) {
  customElements.define("klaviyo-form", KlaviyoForm);
}
export {
  KlaviyoForm,
  KlaviyoForm as default
};
